import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../components/AuthContext';

const BASE_URL = 'http://localhost:8000/api/task';

export default function TaskManagerApp() {
  const { userId, loading } = useAuth();
  const [formData, setFormData] = useState({ title: '', description: '', user_id: '' });
  const [tasks, setTasks] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [titleDraft, setTitleDraft] = useState('');
  const [descriptionDraft, setDescriptionDraft] = useState('');

  useEffect(() => {
    if (loading || !userId) return;
    // Always attach current user_id before fetch
    setFormData(prev => ({ ...prev, user_id: userId }));
    fetchTasks();
  }, [userId, loading]);

  const fetchTasks = async () => {
    try {
      const res = await axios.get(BASE_URL, {
        headers: { Authorization: `Bearer ${localStorage.getItem('bbauthToken')}` },
      });
      setTasks(res.data);
    } catch (err) {
      console.error('Error fetching tasks:', err);
    }
  };

  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Add this helper in your component:
  const startEditing = (task) => {
    setEditingId(task.id);
    setFormData({
      title: task.title,
      description: task.description,
      user_id: userId
    });
  };


  const handleSubmit = async e => {
    e.preventDefault();
    const method = editingId ? 'put' : 'post';
    const url = editingId ? `${BASE_URL}/${editingId}` : `${BASE_URL}/create`;
    try {
      await axios[method](url, formData, {
        headers: { Authorization: `Bearer ${localStorage.getItem('bbauthToken')}` },
      });
      setFormData({ title: '', description: '', user_id: userId });
      setEditingId(null);
      fetchTasks();
    } catch (err) {
      console.error('Error saving task:', err);
    }
  };

  const handleDelete = async id => {
    try {
      await axios.delete(`${BASE_URL}/${id}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('bbauthToken')}` },
      });
      fetchTasks();
    } catch (err) {
      console.error('Error deleting task:', err);
    }
  };

  // New: save inline edits on blur of either field
  const handleInlineBlur = async task => {
    try {
      await axios.put(
        `${BASE_URL}/${task.id}`,
        {
          title: titleDraft,
          description: descriptionDraft,
          user_id: userId,
        },
        { headers: { Authorization: `Bearer ${localStorage.getItem('bbauthToken')}` } }
      );
      setEditingId(null);
      fetchTasks();
    } catch (err) {
      console.error('Error updating task:', err);
    }
  };

  const handleInlineEdit = task => {
    setEditingId(task.id);
    setTitleDraft(task.title);
    setDescriptionDraft(task.description);
  };

  if (loading) return <div>Loading your tasks…</div>;
  if (!userId) return <h2>Please log in to see your tasks.</h2>;

  return (
    <div className="container-fluid p-4">
      <div className="row">
        <nav className="col-md-2 d-none d-md-block bg-light p-3" style={{ minHeight: '100vh' }}>
          {/* … unchanged sidebar … */}
        </nav>
        <main className="col-md-10">
          {/* … unchanged create/edit form … */}
          <div className="row">
            <div className="col-md-8 mb-4">
              <div className="card mb-3">
                <div className="card-header">Your Tasks</div>
                <ul className="list-group list-group-flush">
                  {tasks.map(task => (
                    <li key={task.id} className="list-group-item">
                      {editingId === task.id ? (
                        <div>
                          <input
                            type="text"
                            value={titleDraft}
                            onChange={e => setTitleDraft(e.target.value)}
                            onBlur={() => handleInlineBlur(task)}
                            className="form-control form-control-sm mb-2"
                            autoFocus
                          />
                          <textarea
                            value={descriptionDraft}
                            onChange={e => setDescriptionDraft(e.target.value)}
                            onBlur={() => handleInlineBlur(task)}
                            className="form-control form-control-sm"
                            rows={2}
                          />
                        </div>
                      ) : (
                        <div>
                          <strong
                            onClick={() => startEditing(task)}
                            style={{ cursor: 'pointer', display: 'block' }}
                          >
                            {task.title}
                          </strong>
                          <div
                            onClick={() => startEditing(task)}
                            style={{ cursor: 'pointer', color: '#555', fontSize: '0.9rem' }}
                          >
                            {task.description}
                          </div>
                          <button
                            onClick={() => handleDelete(task.id)}
                            className="btn btn-sm btn-danger mt-2"
                          >
                            Delete
                          </button>
                        </div>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            {/* … unchanged sidebar cards … */}
          </div>
        </main>
      </div>
    </div>
  );
}
